import BaseMapper from '../../BaseMapper';

const LiveMapper = (data, context) => {
    return data;
};

export default LiveMapper;
